module.exports = __webpack_public_path__ + "static/img/21.4f8e982.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/21.png
// module id = ZPOa
// module chunks = 0